import React from "react";
import { Modal, ModalBuilder, Table } from "@redriver/cinnamon";
import EditSignatoryForm from "features/Companies/Customers/Signatories/Actions/EditSignatoryForm";
import {
  getClientAuthorisedSignatory,
  updateClientAuthorisedSignatory,
} from "features/Companies/Customers/Signatories/Actions/actions";

const EditSignatory = ({
  isAuthorised,
  signatoryId,
  clientId,
  forceUpdate,
}) => {
  return (
    <ModalBuilder
      withForm
      submitAction={updateClientAuthorisedSignatory}
      submitParams={{ signatoryId, clientId }}
      onSubmitted={forceUpdate}
      loadAction={getClientAuthorisedSignatory}
      loadParams={{ signatoryId, clientId }}
      renderTrigger={(showModal) => (
        <Table.MenuItem onClick={showModal}>Edit</Table.MenuItem>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit {...modalProps} header="Edit Signatory" submitLabel="Save">
          <EditSignatoryForm
            isAuthorised={isAuthorised}
            signatoryId={signatoryId}
            {...formProps}
          />
        </Modal.Edit>
      )}
    />
  );
};
export default EditSignatory;
